import React, { useState, useEffect, useCallback } from 'react';
import { format, parseISO } from 'date-fns';
import api from '~/services/api';
// Importando componentes
import Card from '~/components/Card';
import Table from '~/components/Table';
import Load from '~/components/Load';

import { Container, Menus, Filtro, DS, Button } from './styles';

export default function RelatorioEmail() {
  const [dados, setDados] = useState([]);
  const [dateInit, setDateInit] = useState(null);
  const [dateFinish, setDateFinish] = useState(null);
  const [reset, setReset] = useState(false);
  const [loading, setLoading] = useState(false);

  const getEmail = useCallback(async () => {
    setLoading(true);
    const responseTarefa = await api.post('/relatorio-email');
    const data = responseTarefa.data.map(email => {
      return {
        ...email,
        dataCriacao: format(parseISO(email.created_at), 'dd/MM/yyyy HH:mm:ss'),
      };
    });
    setDados(data);
    setReset(false);
    setLoading(false);
  }, []);

  useEffect(() => {
    getEmail();
  }, [getEmail]);

  // Criando dados da coluna
  const columns = [
    {
      name: 'id',
      label: 'Id',
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: 'user.name',
      label: 'Nome',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'time.incorporadora.name',
      label: 'Incorporadora',
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: 'time.name',
      label: 'Time',
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: 'atendimento.lead.name',
      label: 'Lead',
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: 'assunto',
      label: 'Assunto',
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: 'status',
      label: 'Status do e-mail',
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: 'dataCriacao',
      label: 'Data de envio do e-mail',
      options: {
        filter: false,
        sort: false,
      },
    },
  ];

  async function handleFiltrar() {
    setLoading(true);
    const data_init = format(dateInit, 'dd/MM/yyyy');
    const data_finish = format(dateFinish, 'dd/MM/yyyy');
    const responseTarefa = await api.post('/relatorio-email', {
      data_init,
      data_finish,
    });
    const data = responseTarefa.data.map(email => {
      return {
        ...email,
        dataCriacao: format(parseISO(email.created_at), 'dd/MM/yyyy HH:mm:ss'),
      };
    });
    setDateInit(null);
    setDateFinish(null);
    setDados(data);
    setReset(true);
    setLoading(false);
  }

  if (loading) {
    return <Load />;
  }

  return (
    <Container>
      <h4>Relatório de e-mails</h4>
      <Card>
        <Menus>
          {reset ? (
            <Button type="button" onClick={getEmail} reset>
              Resetar
            </Button>
          ) : (
            <Filtro>
              <DS
                selected={dateInit}
                onChange={date => setDateInit(date)}
                locale="pt-BR"
                placeholderText="Data inicial"
                dateFormat="dd/MM/yyyy"
                showPopperArrow={false}
                withPortal
              />
              <DS
                selected={dateFinish}
                onChange={date => setDateFinish(date)}
                locale="pt-BR"
                minDate={dateInit}
                placeholderText="Data final"
                dateFormat="dd/MM/yyyy"
                showPopperArrow={false}
                withPortal
              />
              <Button type="button" onClick={handleFiltrar}>
                Filtrar
              </Button>
            </Filtro>
          )}
        </Menus>
        <Table
          title="Integrações"
          data={dados}
          columns={columns}
          ds={() => {}}
          ed={() => {}}
          messages="Você deseja ativar/desativar a incorporadora?"
          dw
        />
      </Card>
    </Container>
  );
}
